<template>
    <div class="homepage-pay-module">
          <div class="col" v-for="(item,key) in payments" :key="key">
              <div class="item">
                  <div class="icon">
                    <img :src="$store.state.main.cdn_url + '/providers/' +  _.toLower(item)  + '.png'" width="60">
                  </div>
                  <div class="info">
                    <div class="slogan">
                       <h5>{{ $t('payment.services.' + item) }} </h5>
                        <small>Hızlı yatırım imkanı !</small>
                    </div>
                    <router-link :to="{ name: 'User', params:{ section: 'deposit'}}" class="button primary">Şimdi Yatırım Yap</router-link>
                  </div>
              </div>
          </div>
    </div>
</template>

<script>
  export default{
    computed:{
      payments(){
        return this.$store.getters['special/getHomePayments']
      }
    }
  }
</script>